import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Icon = _resolveComponent("Icon")

  return (_openBlock(), _createBlock(_component_Icon, {
    class: "pointer",
    stroke: "var(--gray-500)",
    fill: $props.disliked ? 'var(--gray-300)' : 'var(--base-white)',
    width: $props.size,
    height: $props.size,
    "stroke-width": "1",
    icon: "thumbs-down"
  }, null, 8 /* PROPS */, ["fill", "width", "height"]))
}